import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Text, Image } from "@base";
import {
  getTailwindUtility,
  debugLog,
  renderHtmlString,
  isPreview,
} from "../utils/index";
import { PageStateContext } from "../PageContext";

const Header = ({ onFirstPage = false }) => {
  const { pageState } = useContext(PageStateContext);
  // console.log(" >>>>>> GlobalStateContext");
  // console.log(GlobalStateContext);

  if (!pageState || !pageState.chrome) {
    return (
      <div className="header-loading">
        <span>Loading Header...</span>
      </div>
    );
  } 
  const { chrome, uiText, formattedDate } = pageState;
  debugLog("uiTextHeader", uiText);
  debugLog("pageState", pageState);
  debugLog("pageState.uiText", pageState.uiText);
  const {
    title = "Default Title",
    htmlTitle = undefined,
    color = "#000",
    logo = "/path/to/default/logo.png",
  } = chrome;

  const renderedTitle = htmlTitle
    ? isPreview()
      ? renderHtmlString(htmlTitle)
      : title
    : title;
  return (
    <header className={`Header Header--${onFirstPage ? "first" : "not-first"}`}>
      <div
        className="flex items-start text-sm px-6 pt-3 pb-0"
        style={{
          borderTop: `6px solid ${color}`,
          height: 102,
        }}
      >
        {!onFirstPage && logo && (
          <Image image={logo} forceWidth={43 * getTailwindUtility("factor")} />
        )}
        <div className="ml-auto text-right">
          <Text tag="h3" use="label" className="mb-2">
            <span style={{ color }}>{renderedTitle}</span>{" "}
            <span className="text-gray">{uiText.print_user_manual}</span>
          </Text>

          <Text
            tag="h4"
            use="label"
            options={{ font: "font-body", style: "normal-case" }}
          >
            <span className="text-gray">{uiText.screen_manual_selector}</span>{" "}
            <span className="text-gray-2">{formattedDate}</span>
          </Text>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  onFirstPage: PropTypes.bool,
};

export default Header;
